import { SeMappableModel } from '../se-service'

export class Timezone extends SeMappableModel {
  country_code: string
  country_name: string
  identifier: string
  name: string
  offset: string
}
